import { getSessionCookie, deleteSessionCookie, deserialize } from '@core-web/lib';
import type { IConfigurationReducer } from '../types';

export const ConfigurationKey = 'configuration';

export const getConfigurations = (): any => {
  try {
    const _prevConfigs = getSessionCookie(ConfigurationKey);
    return _prevConfigs ? deserialize(_prevConfigs) : null;
  } catch (error) {
    return null;
  }
};

export const getAppConfigurations = (): IConfigurationReducer => {
  const appConfiguration = getConfigurations();
  return {
    staticMenu: appConfiguration?.staticMenu?.value || false,
    apiEndpoint: appConfiguration?.environment?.value || null,
  };
};

export const resetConfigurations = () => {
  deleteSessionCookie(ConfigurationKey);
};
